var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"childbox dn-conten-bg",attrs:{"id":"app"}},[_c('div',{ref:"tapp",staticClass:"box",attrs:{"id":_vm.echartsId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }